import React from 'react';
import { motion } from 'framer-motion';

const StatsCard = ({ icon: Icon, title, value, color }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02, y: -5 }}
      className={`glass-card p-6 bg-gradient-to-br ${color} bg-opacity-20`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-white/80 text-sm mb-1">{title}</p>
          <p className="text-3xl font-bold text-white">{value}</p>
        </div>
        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center">
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </motion.div>
  );
};

export default StatsCard;
